import React, { useState } from 'react';
import styles from './singleAgent.module.scss';
import Header from 'component/layout/header/Header';
import Container from 'component/atom/container/Container';
import AgentHeader from 'component/organism/settings-linkTo-agent/single-agent/header/AgentHeader';
import Button from 'component/atom/forms/button/Button';
import APISection from 'component/organism/settings-linkTo-agent/single-agent/api-section/APISection';
import APILogs from 'component/organism/settings-linkTo-agent/single-agent/api-logs/APILogs';
import { useFetch } from 'hooks/useFetch';
import { Agent } from 'hooks/endpoints';
import { useParams } from 'react-router-dom';
import { formatLastSync } from 'helpers/formatTimeSync';
import { usePost } from 'hooks/usePost';
import Tab from 'component/molecules/Tab/TabComponent';
import DerivedViews from 'component/organism/settings-linkTo-agent/single-agent/derived-views/DerivedViews';

const SingleAgent = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedIds, setSelectedIds] = useState([]);
  const [testStatuses, setTestStatuses] = useState({});
  const [bulkTaskMap, setBulkTaskMap] = useState({});
  const [bulkRunNonce, setBulkRunNonce] = useState(0);
  const [isSyncingAll, setIsSyncingAll] = useState(false);

  const { mutate: SyncAll, isPending: isPendingSync } = usePost();
  const { data: agentResponse } = useFetch(
    ['agent', id],
    Agent.getAgentAPISelection(id),
    {
      enable: true,
    }
  );
  const agentData = agentResponse?.data;
  const isAgentConnected = agentData?.agentInDb?.connectionStatus;

  const renderComponent = (
    <div>
      {0 === activeTab && (
        <div className={styles['action-btns']}>
          <div className={styles.connected}>
            <Button
              label={isSyncingAll ? 'Syncing...' : 'Sync All'}
              type='sync'
              onClick={() => handleSyncAll()}
              // isLoading={isPendingSync}
              disabled={
                isSyncingAll ||
                agentData?.agentInDb?.isSyncingAll ||
                1 !== isAgentConnected
              }
            />
          </div>
        </div>
      )}
    </div>
  );
  const handleSyncAll = () => {
    setIsSyncingAll(true);
    SyncAll(
      {
        url: Agent.SyncAll,
        data: {
          agentId: agentData?.agentInDb?.id,
          isFromFrontend: true,
        },
      },
      {
        onSuccess: (e) => {
          const list = e?.data?.syncResults ?? [];
          const map = list.reduce((acc, x) => {
            acc[x.agentConnectionDetailId] = x.taskId;
            return acc;
          }, {});
          setBulkTaskMap(map);
          setBulkRunNonce((n) => n + 1);
        },
        onError: () => {
          setIsSyncingAll(false);
        },
      }
    );
  };
  const tabs = [
    {
      label: 'API Selections',
      content: (
        <APISection
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          testStatuses={testStatuses}
          setTestStatuses={setTestStatuses}
          bulkTaskMap={bulkTaskMap}
          bulkRunNonce={bulkRunNonce}
          setIsSyncingAll={setIsSyncingAll}
          isAgentConnected={isAgentConnected}
        />
      ),
    },
    { label: 'API Logs', content: <APILogs /> },
    { label: 'Derived Views', content: <DerivedViews agentData={agentData} /> },
  ];
  return (
    <>
      <Header
        title={
          agentData?.agentInDb?.agentType === 1
            ? 'Canvas'
            : agentData?.agentInDb?.agentType === 2
            ? 'Blackboard'
            : agentData?.agentInDb?.agentType === 3
            ? 'Banner'
            : ''
        }
        isBack
        isSub
      />
      <Container className={styles.agentCont}>
        <AgentHeader
          title={agentData?.agentInDb?.agentName}
          subTitle={`Last Synced: ${formatLastSync(
            agentData?.overallLastSyncTime
          )}`}
          subtitleSvg='sync'
          renderComponent={renderComponent}
        />
        <Tab
          tabs={tabs}
          activeTab={activeTab}
          onChange={setActiveTab}
          className={styles['tab-class']}
        />
      </Container>
    </>
  );
};

export default SingleAgent;
